import React from "react";
import { Box, Typography, Divider } from "@mui/material";
import { useTranslation } from "react-i18next";
import Header from "../components/Header";
import Footer from "../components/Footer";

const ShippingDeliveryPolicy = () => {
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <Box sx={styles.container}>
        <Typography variant="h4" sx={styles.header}>
          {t("shipping_delivery_title")}
        </Typography>
            <Typography variant="body1" paragraph>
                <strong> {t("effective_date")} </strong> 4th December 2025
              </Typography>
        {/* INTRO */}
        <Typography sx={styles.intro} paragraph>{t("shipping_delivery_intro_1")}</Typography>
        <Typography sx={styles.intro} paragraph>{t("shipping_delivery_intro_2")}</Typography>
        <Typography sx={styles.intro} paragraph>{t("shipping_delivery_intro_3")}</Typography>
        <Typography sx={styles.intro} paragraph>{t("shipping_delivery_intro_4")}</Typography>
        <Typography sx={styles.intro} paragraph>{t("shipping_delivery_intro_5")}</Typography>
        <Typography sx={styles.intro} paragraph>{t("shipping_delivery_intro_6")}</Typography>

        <Divider sx={{ my: 3 }} />

        {/* SECTION 1 */}
        <Box sx={styles.section}>
          <Typography variant="h5" sx={styles.subHeader}>
            {t("shipping_delivery_section_1_title")}
          </Typography>
          <Typography paragraph>{t("shipping_delivery_section_1_primary_area")}</Typography>
          <Typography paragraph>{t("shipping_delivery_section_1_exclusion")}</Typography>
        </Box>

        <Divider sx={{ my: 2 }} />

        {/* SECTION 2 */}
        <Box sx={styles.section}>
          <Typography variant="h5" sx={styles.subHeader}>
            {t("shipping_delivery_section_2_title")}
          </Typography>
          <Typography paragraph>{t("shipping_delivery_section_2_time_slots")}</Typography>
          <Typography paragraph>{t("shipping_delivery_section_2_lead_time")}</Typography>
          <Typography paragraph>{t("shipping_delivery_section_2_same_day")}</Typography>
        </Box>

        <Divider sx={{ my: 2 }} />

        {/* SECTION 3 */}
        <Box sx={styles.section}>
          <Typography variant="h5" sx={styles.subHeader}>
            {t("shipping_delivery_section_3_title")}
          </Typography>
          <Typography paragraph>{t("shipping_delivery_section_3_p1")}</Typography>
          <Typography paragraph>{t("shipping_delivery_section_3_p2")}</Typography>
          <Typography paragraph>{t("shipping_delivery_section_3_p3")}</Typography>
          <Typography paragraph>{t("shipping_delivery_section_3_p4")}</Typography>
          <Typography paragraph>{t("shipping_delivery_section_3_p5")}</Typography>
        </Box>

        <Divider sx={{ my: 2 }} />

        {/* SECTION 4 */}
        <Box sx={styles.section}>
          <Typography variant="h5" sx={styles.subHeader}>
            {t("shipping_delivery_section_4_title")}
          </Typography>
          <Typography paragraph>{t("shipping_delivery_section_4_p1")}</Typography>
          <Typography paragraph>{t("shipping_delivery_section_4_p2")}</Typography>
          <Typography paragraph>{t("shipping_delivery_section_4_p3")}</Typography>
          <Typography paragraph>{t("shipping_delivery_section_4_p4")}</Typography>
          <ul>
            <li><Typography paragraph>{t("shipping_delivery_section_4_p5")}</Typography></li>
              <li><Typography paragraph>{t("shipping_delivery_section_4_p6")}</Typography></li>
                                         <li><Typography paragraph>{t("shipping_delivery_section_4_p7")}</Typography></li>
          </ul>
        </Box>

        <Divider sx={{ my: 2 }} />

        {/* SECTION 5 */}
        <Box sx={styles.section}>
          <Typography variant="h5" sx={styles.subHeader}>
            {t("shipping_delivery_section_5_title")}
          </Typography>
          <Typography paragraph>{t("shipping_delivery_section_5_p1")}</Typography>
          <Typography paragraph>{t("shipping_delivery_section_5_p2")}</Typography>
          <Typography paragraph>{t("shipping_delivery_section_5_p3")}</Typography>
          <Typography paragraph>{t("shipping_delivery_section_5_p4")}</Typography>
          <Typography paragraph>{t("shipping_delivery_section_5_p5")}</Typography>
        </Box>

        <Divider sx={{ my: 2 }} />

        {/* SECTION 6 */}
        <Box sx={styles.section}>
          <Typography variant="h5" sx={styles.subHeader}>
            {t("shipping_delivery_section_6_title")}
          </Typography>
          <Typography paragraph>{t("shipping_delivery_section_6_p1")}</Typography>
          <Typography paragraph>{t("shipping_delivery_section_6_p2")}</Typography>
          <Typography paragraph>{t("shipping_delivery_section_6_p3")}</Typography>
          <Typography paragraph>{t("contact_us_number")}</Typography>
          <Typography paragraph>{t("contact_us_email")}</Typography>


        </Box>
      </Box>

      <Footer />
    </>
  );
};

const styles = {
  container: {
    padding: 4,
    maxWidth: 850,
    margin: "40px auto",
    backgroundColor: "#fff",
    borderRadius: 2,
    boxShadow: 3
  },
  header: {
    color: "#00704A",
    borderBottom: "2px solid #EEE",
    paddingBottom: 1
  },
  intro: {
    marginBottom: 2,
    fontSize: "1.05rem"
  },
  section: {
    marginBottom: 3
  },
  subHeader: {
    fontWeight: "bold",
    marginBottom: 1,
    color: "#333"
  }
};

export default ShippingDeliveryPolicy;
